module.exports = __webpack_public_path__ + "static/img/storecode.38d52f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/storecode.png
// module id = duxS
// module chunks = 0